import Utils from './utils';

export default class Decoder {
  static base: number[] | null = null;

  static setBase = (base: any) => {
    Decoder.base = null;
    if (base && base.length > 2) {
      Decoder.base = base;
    }
  };

  static encode = (str: string) => {
    var bytes = Utils.UTFtoArray(str);
    return Decoder.modifyBytes(bytes);
  };

  // uint8array
  static decode = (bytes: any) => {
    var b = Decoder.modifyBytes(bytes);
    return Utils.arrayToUTF(b);
  };

  static modifyBytes = (bytes: any) => {
    if (Decoder.base !== null) {
      for (let i = 0, j = Decoder.base.length; i < bytes.length; ++i) {
        bytes[i] = Utils.decToInt8(bytes[i] ^ Decoder.base[--j]);
        if (j === 0) {
          j = Decoder.base.length;
        }
      }
    }
    return bytes;
  };
}
